
const hamburgers = document.querySelectorAll(".hamburger");
if (hamburgers.length > 0) {
    hamburgers.forEach(function(hamburger) {
        hamburger.addEventListener("click", function() {
            this.classList.toggle("is-active");
            let nav = document.querySelector("header nav")
            nav.classList.toggle("is-active")
        }, false);
    });
}

// 選單
const menuBtns = document.querySelectorAll("header nav ul a[href^='#box'], header nav ul a[href^='#top']")
menuBtns.forEach(function(btn) {
    btn.addEventListener("click", function(e) {
        e.preventDefault()

        document.querySelector(".hamburger").classList.toggle("is-active")
        document.querySelector("header nav").classList.toggle("is-active")

        let h =document.querySelector("header").offsetHeight;

        const href = this.getAttribute("href");
        const offsetTop = document.querySelector(href).offsetTop -h;

        scroll({
            top: offsetTop,
            behavior: "smooth"
        })
    })
})